import { render } from "./ChangeoverCauseTable.vue?vue&type=template&id=90cf924c&scoped=true"
import script from "./ChangeoverCauseTable.vue?vue&type=script&lang=js"
export * from "./ChangeoverCauseTable.vue?vue&type=script&lang=js"

import "./ChangeoverCauseTable.vue?vue&type=style&index=0&id=90cf924c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90cf924c"]])

export default __exports__
import QTable from 'quasar/src/components/table/QTable.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTh from 'quasar/src/components/table/QTh.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QTd from 'quasar/src/components/table/QTd.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QTable,QTr,QTh,QTooltip,QTd});
